import { api, clearAccessToken, setAccessToken } from './client'

export async function login(email, password, totpCode, rememberMfa = false) {
  const body = { email, password, remember_mfa: Boolean(rememberMfa) }
  if (totpCode) body.totp_code = totpCode
  const { data } = await api.post('/auth/login', body)
  setAccessToken(data.access_token)
  return data
}

export async function logout() {
  try {
    await api.post('/auth/logout')
  } finally {
    clearAccessToken()
  }
}

export async function fetchCurrentUser() {
  const { data } = await api.get('/auth/me')
  return data
}

export async function refreshSession() {
  const { data } = await api.post('/auth/refresh')
  setAccessToken(data.access_token)
  return data
}

export async function setupMfa() {
  const { data } = await api.post('/auth/mfa/setup')
  return data
}

export async function confirmMfa(code) {
  const { data } = await api.post('/auth/mfa/confirm', { code })
  return data
}

export async function changePassword(currentPassword, newPassword) {
  const { data } = await api.post('/auth/change-password', {
    current_password: currentPassword,
    new_password: newPassword,
  })
  return data
}
